import React from 'react';
export function Footer() {
  return <footer className="bg-[#111827] text-[#F5F0E8] py-16 border-t border-[#F5F0E8]/10" data-id="element-25">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col items-center text-center" data-id="element-26">
        <h2 className="font-serif text-2xl tracking-wide mb-8" data-id="element-27">
          Jabotinsky Legacy Fund
        </h2>

        <blockquote className="max-w-2xl text-[#F5F0E8]/60 font-serif italic mb-12 text-lg" data-id="element-28">
          "Tell them three things in my name, and not two: they must get iron;
          they must choose a king; and they must learn to laugh."
        </blockquote>

        <div className="flex flex-wrap justify-center gap-8 mb-12 text-sm tracking-wider uppercase text-[#F5F0E8]/50" data-id="element-29">
          <a href="#about" className="hover:text-[#B8860B] transition-colors" data-id="element-30">
            About
          </a>
          <a href="#philosophy" className="hover:text-[#B8860B] transition-colors" data-id="element-31">
            Philosophy
          </a>
          <a href="#legacy" className="hover:text-[#B8860B] transition-colors" data-id="element-32">
            Legacy
          </a>
          <a href="#fund" className="hover:text-[#B8860B] transition-colors" data-id="element-33">
            The Fund
          </a>
          <a href="mailto:contact@jabotinskyfund.org" className="hover:text-[#B8860B] transition-colors" data-id="element-34">
            Contact
          </a>
        </div>

        <a href="#" className="inline-block text-[#F5F0E8]/30 hover:text-[#B8860B] text-xs uppercase tracking-widest mb-8 transition-colors" data-id="element-35">
          Back to Top ↑
        </a>

        <div className="text-[#F5F0E8]/40 text-sm" data-id="element-36">
          &copy; {new Date().getFullYear()} The Jabotinsky Legacy Fund. All
          rights reserved.
        </div>
        <div className="text-[#F5F0E8]/30 text-xs mt-2" data-id="element-37">jabotinskyfund.org</div>
      </div>
    </footer>;
}